export default __webpack_public_path__ + "static/ombralsun-scheda-tecnica-d5039ba0ee5a4fb01cd2ccf161a11f3d.pdf";